(ns thi.ng.geom.version)

(def ^:export version "1.0.0-RC3")
